var isPlainObject = function isPlainObject(obj) {
  var _Object$getPrototypeO;

  return !!obj && typeof obj === "object" && (((_Object$getPrototypeO = Object.getPrototypeOf(obj)) === null || _Object$getPrototypeO === void 0 ? void 0 : _Object$getPrototypeO.constructor.name) === "Object" || Object.getPrototypeOf(obj) === null);
};

export default isPlainObject;